import { render, staticRenderFns } from "./SaleRegionList.vue?vue&type=template&id=5a25e107&scoped=true&"
import script from "./SaleRegionList.vue?vue&type=script&lang=js&"
export * from "./SaleRegionList.vue?vue&type=script&lang=js&"
import style0 from "./SaleRegionList.vue?vue&type=style&index=0&id=5a25e107&lang=scss&scoped=true&"
import style1 from "./SaleRegionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a25e107",
  null
  
)

export default component.exports